import ProjectTeamPaymentsModalComponent from './payments-modal.component'

const ProjectTeamPaymentsModalModule = angular.module('cdbl.project-team.payments-modal', [

])
  .component('cdblProjectTeamPaymentsModal', ProjectTeamPaymentsModalComponent)
  .name

export default ProjectTeamPaymentsModalModule
